import { render, staticRenderFns } from "./PreviewDocumentsSideASide.vue?vue&type=template&id=0c247b18"
import script from "./PreviewDocumentsSideASide.vue?vue&type=script&lang=js"
export * from "./PreviewDocumentsSideASide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports